import React, { FC, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { AddTransportContext } from 'pages/transport/add-transport/add-transport-context';
import { LoadingButton } from '@mui/lab';

type TransportDetailsStepProps = {
    onNavigateBack: () => void;
    onPlaceOrder: (shouldAddMore: boolean) => void;
    loading: boolean;
};
const TransportDetailsStep: FC<TransportDetailsStepProps> = ({
    onNavigateBack,
    onPlaceOrder,
    loading,
}: TransportDetailsStepProps) => {
    const { t: translate } = useTranslation(['common', 'transport']);
    const { transportOrderReq, setTransportOrderReq } = useContext(AddTransportContext);

    return (
        <Box>
            <Box mb={4}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        <FormControl fullWidth>
                            <InputLabel id="no-of-packages-label">
                                {translate('transport:NUMBER_OF_PACKAGES')}
                            </InputLabel>
                            <Select
                                labelId="no-of-packages-label"
                                value={transportOrderReq.manualPackageCount}
                                label={translate('transport:NUMBER_OF_PACKAGES')}
                                onChange={(event) =>
                                    setTransportOrderReq({
                                        ...{
                                            ...transportOrderReq,
                                            manualPackageCount: event.target.value as number,
                                        },
                                    })
                                }
                            >
                                {Array.from(Array(20).keys()).map((value) => (
                                    <MenuItem key={value + 1} value={value + 1}>
                                        {value + 1}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={8}>
                        <TextField
                            fullWidth
                            value={transportOrderReq.comment || ''}
                            label={translate('transport:MESSAGE_TO_CARRIER')}
                            onChange={(event) =>
                                setTransportOrderReq({
                                    ...{
                                        ...transportOrderReq,
                                        comment: event.target.value,
                                    },
                                })
                            }
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            value={transportOrderReq.internalMessage || ''}
                            label={translate('transport:INTERNAL_MESSAGE')}
                            onChange={(event) => {
                                setTransportOrderReq({
                                    ...{
                                        ...transportOrderReq,
                                        internalMessage: event.target.value,
                                    },
                                });
                            }}
                        />
                    </Grid>
                </Grid>
            </Box>
            <Box display="flex">
                <Box flexGrow={1}>
                    <Button onClick={onNavigateBack}>{translate('common:BACK')}</Button>
                </Box>
                <Box sx={{ display: { xs: 'none', sm: 'block' }, marginRight: 1 }}>
                    <LoadingButton
                        loading={loading}
                        sx={{ display: { xs: 'none', sm: 'block' }, marginRight: 1 }}
                        onClick={() => onPlaceOrder(true)}
                    >
                        <span>{translate('transport:ORDER_TRANSPORT_ADD_MORE')}</span>
                    </LoadingButton>
                </Box>
                <Box>
                    <LoadingButton loading={loading} variant="contained" onClick={() => onPlaceOrder(false)}>
                        {translate('transport:ORDER_TRANSPORT')}
                    </LoadingButton>
                </Box>
            </Box>
        </Box>
    );
};

export default TransportDetailsStep;
